import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Physician-facing clinical forms. Session replay is skipped here for two
// reasons: these pages carry patient PHI (name, SSN, diagnoses, treatment
// history) that must not ride into the replay ingest — the same rationale that
// keeps PII out of the prefill URLs — and the recorder's DOM-mutation
// observer is expensive on a 125-field DocuSeal form.
const NO_REPLAY_PATHS = ['/mental-rfc', '/physical-rfc', '/rep_doc_1696'];
const replayAllowed = !NO_REPLAY_PATHS.includes(window.location.pathname);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Load the recorder as its own chunk, after the page is interactive, so it
// never sits on the critical path ahead of the form.
if (replayAllowed) {
  const startReplay = () => {
    Promise.all([
      import('@openreplay/tracker'),
      import('@openreplay/tracker-assist'),
    ])
      .then(([{ default: Tracker }, { default: trackerAssist }]) => {
        const tracker = new Tracker({
          projectKey: 'jr8Nej1hsn69AHztGnDS',
          ingestPoint: 'https://marketing.aiagent.attorney/ingest',
        });
        tracker.use(trackerAssist({}));
        tracker.start();
      })
      .catch(() => { /* replay is best-effort; never block the form */ });
  };
  if (window.requestIdleCallback) {
    window.requestIdleCallback(startReplay, { timeout: 5000 });
  } else {
    window.addEventListener('load', () => setTimeout(startReplay, 2000));
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
